export default "__VITE_ASSET__070b3bb3__"